import React from 'react';
import { connect } from 'react-redux';

const ErrorMessage = ({ errorMessages, displayErrors, params }) => {
  if (!displayErrors || !errorMessages || errorMessages.length === 0) {
    return null;
  }
  // Display recent available error in redux
  const errorMessage = errorMessages.find(e => e && !e.inline);
  if (!errorMessage) {
    return null;
  }
  let classes = ['vds-form__group'];
  if (params) {
    if (params.errorMessagePadding) {
      classes.push(`vds-padding-bottom-spacing-${params.errorMessagePadding}`);
    }
  }
  return (
    <div className={classes.join(' ')}>
      <div className="vds-form__validation-message vds-form__validation-message--invalid">
        <span
          className="vds-form__validation-text"
          data-errormessageorigin={errorMessage.name}
          data-errormessagetype={errorMessage.type}
          data-testid="error-message"
        >
          {errorMessage.message}
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    errorMessages:
      props.errorMessage !== undefined ? [props.errorMessage] : state.appState?.errorMessages,
    displayErrors:
      props.displayErrors !== undefined ? props.displayErrors : state.appState?.displayErrors,
  };
};
export default connect(mapStateToProps)(ErrorMessage);
